import { useQuery } from "@tanstack/react-query";
import { useProperty } from "../../components/property-provider";
import { accommodationQueryKeys } from "./accommodation.queryKeys";
import { useAccommodationApi } from "./infrastructure/api/accommodation.api";

export function useAccommodationsQuery(propertyTicker?: string, enabled = true) {
  const property = useProperty();
  const { getAccommodations } = useAccommodationApi();
  const ticker = propertyTicker ?? property.ticker;

  return useQuery({
    queryKey: accommodationQueryKeys.list(ticker),
    queryFn: () => getAccommodations(ticker),
    enabled: enabled && !!ticker,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
  });
}
